// extracted by css-extract-rspack-plugin
export default {"navbarSearchContainer":"navbarSearchContainer_dCNk"};